export class PromoParser {
    promo;
    constructor(promo) {
        this.promo = promo;
    }
    getType() {
        if (this.promo && this.promo.type === 'free_item') {
            return 'free_item';
        }
        else if (this.promo &&
            this.promo.type === 'conventional_discount') {
            return 'conventional_discount';
        }
        return 'discount';
    }
    isOncePerCustomer() {
        if (this.getType() === 'discount') {
            return this.promo.once_per_customer;
        }
        else if (this.getType() === 'conventional_discount') {
            return this.promo.restrictions.once_per_customer;
        }
        return this.promo.restrictions.once_per_customer;
    }
    isLoggedInOnly() {
        if (this.getType() === 'discount') {
            return this.promo.logged_in_only;
        }
        else if (this.getType() === 'conventional_discount') {
            return this.promo.restrictions.authenticated_user_only;
        }
        return this.promo.restrictions.authenticated_user_only;
    }
    getFixedDiscount() {
        if (this.getType() === 'discount') {
            return this.promo.fixed_discount;
        }
        if (this.getType() === 'conventional_discount' &&
            this.promo.condition.type ===
                'fixed_amount') {
            return this.promo.condition.discount_value;
        }
        return;
    }
    getPercentDiscount() {
        if (this.getType() === 'discount') {
            return this.promo.percent_discount;
        }
        if (this.getType() === 'conventional_discount' &&
            this.promo.condition.type === 'percentage') {
            return this.promo.condition.discount_value;
        }
        return;
    }
    getMinOrder() {
        if (this.getType() === 'discount') {
            return this.promo.min_order;
        }
        return null;
    }
    getMaxAmount() {
        if (this.getType() === 'discount') {
            return this.promo.max_amount;
        }
        return null;
    }
    getLimitToDishes() {
        if (this.getType() === 'discount') {
            return this.promo.limit_to_dishes;
        }
        return this.promo.condition.eligible_items;
    }
    getFreeDishes() {
        if (this.getType() === 'discount') {
            return this.promo.free_dishes;
        }
        return null;
    }
    getFreeSameOnly() {
        if (this.getType() === 'discount') {
            return this.promo.free_same_only;
        }
        return;
    }
    getFreeQty() {
        if (this.getType() === 'discount') {
            return this.promo.free_qty || 1;
        }
        return 1;
    }
    getFreeRequiredPurchaseQty() {
        if (this.getType() === 'discount') {
            return this.promo.free_required_purchase_qty || 1;
        }
        return 1;
    }
    getFreeDelivery() {
        if (this.getType() === 'discount') {
            return this.promo.free_delivery;
        }
        return;
    }
    getPaymentMethods() {
        if (this.getType() === 'discount') {
            return this.promo.payment_methods;
        }
        else if (this.getType() === 'conventional_discount') {
            return this.promo.restrictions.payment_methods;
        }
        return this.promo.restrictions.payment_methods;
    }
    isDisable() {
        if (this.getType() === 'free_item') {
            return this.promo.disabled;
        }
        if (this.getType() === 'discount') {
            return this.promo.disabled;
        }
        return this.promo.disabled;
    }
    getDeal() {
        if (this.getType() === 'conventional_discount') {
            return this.promo.condition.deal;
        }
        if (this.getType() === 'free_item') {
            return this.promo.condition.deal;
        }
        return null;
    }
    getApplyTo() {
        if (this.getType() === 'conventional_discount') {
            return this.promo.condition.apply_to;
        }
        return null;
    }
}
//# sourceMappingURL=index.js.map